<div class="terminal">
    <pre>curl -L "<a href={{terminal_string}}>{{terminal_string}}</a>"</pre>
</div>